(() => {
  const $ = (selector, context = document) => context.querySelector(selector);
  const $$ = (selector, context = document) => [...context.querySelectorAll(selector)];
  const body = document.body;
  const header = $('[data-header]');
  const stickyHeaderEnabled = header?.dataset.stickyEnabled === 'true';
  const cartBehavior = header?.dataset.cartBehavior || 'page';
  const routeRoot = window.Shopify?.routes?.root || '/';
  const route = (path = '') => `${routeRoot.replace(/\/?$/, '/')}${String(path).replace(/^\/+/, '')}`;
  const reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches || matchMedia('(max-width: 749px)').matches || body.dataset.shopifyDesignMode === 'true';
  const escapeHTML = (value) => String(value ?? '').replace(/[&<>'"]/g, (char) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', "'": '&#39;', '"': '&quot;'
  }[char]));
  const safeStoreURL = (value) => {
    try {
      const parsed = new URL(value, location.origin);
      return parsed.origin === location.origin
        ? escapeHTML(`${parsed.pathname}${parsed.search}${parsed.hash}`)
        : '#';
    } catch (_error) {
      return '#';
    }
  };

  const panels = {
    menu: {
      element: $('[data-mobile-menu]'), overlay: $('[data-menu-overlay]'),
      openers: $$('[data-menu-open]'), closers: $$('[data-menu-close]')
    },
    search: {
      element: $('[data-search-overlay]'), overlay: null,
      openers: $$('[data-search-open]'), closers: $$('[data-search-close]')
    },
    cart: {
      element: $('[data-cart-drawer]'), overlay: $('[data-cart-overlay]'),
      openers: $$('[data-cart-open]'), closers: $$('[data-cart-close]')
    }
  };
  let lastPanelTrigger = null;

  function syncPageLock() {
    const open = Object.values(panels).some(({ element }) => element?.classList.contains('open'))
      || $('[data-wishlist-drawer]')?.classList.contains('open');
    body.classList.toggle('panel-open', Boolean(open));
  }

  function setPanel(name, open, trigger = null, restoreFocus = true) {
    const current = panels[name];
    if (!current?.element) return;
    if (open) {
      Object.keys(panels).forEach((key) => {
        if (key !== name) setPanel(key, false, null, false);
      });
      lastPanelTrigger = trigger || document.activeElement;
    }
    current.element.classList.toggle('open', open);
    current.element.setAttribute('aria-hidden', String(!open));
    current.overlay?.classList.toggle('open', open);
    current.openers.forEach((button) => button.setAttribute('aria-expanded', String(open)));
    syncPageLock();
    if (open) {
      const preferred = name === 'search'
        ? $('[data-search-input]', current.element)
        : $('[data-menu-close], [data-cart-close]', current.element);
      setTimeout(() => {
        if (current.element.classList.contains('open')) preferred?.focus();
      }, reducedMotion ? 0 : 220);
    } else if (restoreFocus && lastPanelTrigger instanceof HTMLElement) {
      lastPanelTrigger.focus({ preventScroll: true });
      lastPanelTrigger = null;
    }
  }

  Object.entries(panels).forEach(([name, current]) => {
    current.openers.forEach((button) => button.addEventListener('click', () => setPanel(name, true, button)));
    current.closers.forEach((button) => button.addEventListener('click', () => setPanel(name, false)));
    current.overlay?.addEventListener('click', () => setPanel(name, false));
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') {
      const openName = Object.keys(panels).find((name) => panels[name].element?.classList.contains('open'));
      if (openName) setPanel(openName, false);
    }
    if (event.key !== 'Tab') return;
    const openPanel = Object.values(panels).find(({ element }) => element?.classList.contains('open'))?.element;
    if (!openPanel) return;
    const focusable = $$('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])', openPanel)
      .filter((element) => element.getClientRects().length);
    if (!focusable.length) return;
    const first = focusable[0];
    const last = focusable[focusable.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  let headerTicking = false;
  const parallaxItems = $$('[data-parallax]');
  function handleScroll() {
    header?.classList.toggle('scrolled', stickyHeaderEnabled && scrollY > 100);
    if (!reducedMotion) {
      parallaxItems.forEach((element) => {
        const rect = element.getBoundingClientRect();
        const speed = Number(element.dataset.speed || 0.05);
        if (rect.bottom > 0 && rect.top < innerHeight) {
          element.style.transform = `translate3d(0, ${(rect.top - innerHeight / 2) * speed}px, 0)`;
        }
      });
    }
    headerTicking = false;
  }
  addEventListener('scroll', () => {
    if (!headerTicking) {
      requestAnimationFrame(handleScroll);
      headerTicking = true;
    }
  }, { passive: true });
  handleScroll();

  if (!reducedMotion && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('visible');
        observer.unobserve(entry.target);
      }
    }), { threshold: 0.12 });
    $$('[data-reveal]').forEach((element) => observer.observe(element));
  } else {
    $$('[data-reveal]').forEach((element) => element.classList.add('visible'));
  }

  if (!reducedMotion) {
    $$('.magnetic').forEach((element) => {
      element.addEventListener('mousemove', (event) => {
        if (innerWidth < 990) return;
        const rect = element.getBoundingClientRect();
        element.style.transform = `translate(${(event.clientX - rect.left - rect.width / 2) * 0.08}px, ${(event.clientY - rect.top - rect.height / 2) * 0.08}px)`;
      });
      element.addEventListener('mouseleave', () => { element.style.transform = ''; });
    });
  }

  const ripple = $('[data-cursor-ripple]');
  if (ripple && matchMedia('(pointer: fine)').matches && !reducedMotion) {
    addEventListener('mousemove', (event) => {
      ripple.style.left = `${event.clientX}px`;
      ripple.style.top = `${event.clientY}px`;
      ripple.classList.add('visible');
    }, { passive: true });
    $$('a, button, input, select, textarea').forEach((element) => {
      element.addEventListener('mouseenter', () => ripple.classList.add('hovering'));
      element.addEventListener('mouseleave', () => ripple.classList.remove('hovering'));
    });
  }

  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-CA', {
    style: 'currency', currency: body.dataset.currency || 'CAD'
  }).format(Number(cents || 0) / 100);

  async function fetchJSON(url, options) {
    const response = await fetch(url, options);
    let data = null;
    try { data = await response.json(); } catch (_error) { /* non-JSON response */ }
    if (!response.ok) throw new Error(data?.description || data?.message || 'Something went wrong. Please try again.');
    return data;
  }

  async function refreshCart(open = true) {
    const id = header?.dataset.sectionId;
    if (!id) {
      location.assign(route('cart'));
      return;
    }
    const response = await fetch(route(`?sections=${encodeURIComponent(id)}`), { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('The bag could not be refreshed.');
    const sections = await response.json();
    if (!sections?.[id]) throw new Error('The bag response was incomplete.');
    const parsed = new DOMParser().parseFromString(sections[id], 'text/html');
    const fresh = parsed.querySelector('[data-cart-content]');
    const target = $('[data-cart-content]');
    const pendingNote = target?.querySelector('textarea[name="note"]')?.value;
    const pendingWrap = target?.querySelector('input[type="checkbox"][name="attributes[Gift wrapping requested]"]')?.checked;
    if (fresh && target) {
      target.innerHTML = fresh.innerHTML;
      const refreshedNote = target.querySelector('textarea[name="note"]');
      const refreshedWrap = target.querySelector('input[type="checkbox"][name="attributes[Gift wrapping requested]"]');
      if (refreshedNote && pendingNote !== undefined) refreshedNote.value = pendingNote;
      if (refreshedWrap && pendingWrap !== undefined) refreshedWrap.checked = pendingWrap;
    }
    const count = parsed.querySelector('[data-cart-count]')?.textContent?.trim() || '0';
    $$('[data-cart-count]').forEach((element) => { element.textContent = count; });
    bindCart();
    if (open) setPanel('cart', true, document.activeElement);
  }

  async function addVariant(id, quantity = 1, properties = undefined) {
    const variantId = Number(id);
    if (!Number.isFinite(variantId) || variantId <= 0) throw new Error('This product option is unavailable.');
    const item = { id: variantId, quantity: Math.max(1, Number(quantity) || 1) };
    if (properties) item.properties = properties;
    await fetchJSON(route('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [item] })
    });
    if (cartBehavior === 'page') {
      location.assign(route('cart'));
      return;
    }
    await refreshCart(true);
  }

  function bindQuickAdd(context = document) {
    $$('[data-quick-add]', context).forEach((button) => {
      if (button.dataset.bound === 'true') return;
      button.dataset.bound = 'true';
      button.addEventListener('click', async () => {
        const original = button.textContent;
        button.disabled = true;
        button.textContent = 'Adding…';
        try { await addVariant(button.dataset.quickAdd); }
        catch (error) { alert(error.message); }
        finally { button.disabled = false; button.textContent = original; }
      });
    });
  }
  bindQuickAdd();

  function bindCart() {
    $$('[data-line]').forEach((line) => {
      const lineNumber = Number(line.dataset.line);
      line.querySelectorAll('[data-qty]').forEach((button) => {
        button.onclick = async () => {
          const current = Number($('.qty span', line)?.textContent || 0);
          const quantity = Math.max(0, current + Number(button.dataset.qty));
          button.disabled = true;
          try {
            await fetchJSON(route('cart/change.js'), {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ line: lineNumber, quantity })
            });
            await refreshCart(false);
          } catch (error) { button.disabled = false; alert(error.message); }
        };
      });
      const remove = $('[data-remove]', line);
      if (remove) remove.onclick = async () => {
        remove.disabled = true;
        try {
          await fetchJSON(route('cart/change.js'), {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ line: lineNumber, quantity: 0 })
          });
          await refreshCart(false);
        } catch (error) { remove.disabled = false; alert(error.message); }
      };
    });
    const cartArea = $('[data-cart-content]');
    const note = cartArea?.querySelector('textarea[name="note"]');
    const wrapping = cartArea?.querySelector('input[type="checkbox"][name="attributes[Gift wrapping requested]"]');
    if (note && note.dataset.bound !== 'true') {
      note.dataset.bound = 'true';
      note.addEventListener('change', async () => {
        try {
          await fetchJSON(route('cart/update.js'), {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ note: note.value })
          });
        } catch (error) { alert(error.message); }
      });
    }
    if (wrapping && wrapping.dataset.bound !== 'true') {
      wrapping.dataset.bound = 'true';
      wrapping.addEventListener('change', async () => {
        try {
          await fetchJSON(route('cart/update.js'), {
            method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ attributes: { 'Gift wrapping requested': wrapping.checked ? 'Yes' : '' } })
          });
        } catch (error) { alert(error.message); }
      });
    }
  }
  bindCart();

  const searchInput = $('[data-search-input]');
  const searchResults = $('[data-predictive-results]');
  let searchTimer;
  let searchController;
  searchInput?.addEventListener('input', () => {
    clearTimeout(searchTimer);
    searchController?.abort();
    const query = searchInput.value.trim();
    if (query.length < 2) {
      searchResults.removeAttribute('aria-busy');
      searchResults.innerHTML = '<p>Begin typing to discover pieces and collections.</p>';
      return;
    }
    searchResults.setAttribute('aria-busy', 'true');
    searchTimer = setTimeout(async () => {
      searchController = new AbortController();
      try {
        const data = await fetchJSON(route(`search/suggest.json?q=${encodeURIComponent(query)}&resources[type]=product,collection&resources[limit]=6`), {
          signal: searchController.signal, headers: { Accept: 'application/json' }
        });
        const products = data?.resources?.results?.products || [];
        const collections = data?.resources?.results?.collections || [];
        searchResults.innerHTML = [
          ...products.map((product) => `<a class="predictive-item" href="${safeStoreURL(product.url)}">${product.image ? `<img src="${escapeHTML(product.image)}" alt="" loading="lazy">` : ''}<span>${escapeHTML(product.title)}<small>${escapeHTML(product.price)}</small></span></a>`),
          ...collections.map((collection) => `<a class="predictive-item" href="${safeStoreURL(collection.url)}"><span>Collection<br><strong>${escapeHTML(collection.title)}</strong></span></a>`)
        ].join('') || '<p>No results found.</p>';
      } catch (error) {
        if (error.name !== 'AbortError') searchResults.innerHTML = '<p>Search is temporarily unavailable. Please submit your search instead.</p>';
      } finally { searchResults.removeAttribute('aria-busy'); }
    }, 250);
  });

  const wishKey = 'philistia-wishlist';
  function loadWishes() {
    try {
      const saved = JSON.parse(localStorage.getItem(wishKey) || '[]');
      return Array.isArray(saved) ? saved.filter((handle) => typeof handle === 'string') : [];
    } catch (_error) { return []; }
  }
  let wishes = loadWishes();
  function paintWish() {
    $$('[data-wishlist-toggle]').forEach((button) => {
      const active = wishes.includes(button.dataset.handle);
      button.classList.toggle('active', active);
      button.setAttribute('aria-pressed', String(active));
    });
    $$('[data-wishlist-count]').forEach((count) => { count.textContent = wishes.length; });
  }
  $$('[data-wishlist-toggle]').forEach((button) => button.addEventListener('click', () => {
    const handle = button.dataset.handle;
    if (!handle) return;
    wishes = wishes.includes(handle) ? wishes.filter((item) => item !== handle) : [...wishes, handle];
    localStorage.setItem(wishKey, JSON.stringify(wishes));
    paintWish();
  }));
  paintWish();

  const mapFact = (label, arabic, value, wide = false) => value ? `
    <article class="map-fact${wide ? ' map-fact--wide' : ''}">
      <p class="map-detail__label"><span>${label}</span><em lang="ar" dir="rtl">${arabic}</em></p>
      <p>${escapeHTML(value)}</p>
    </article>` : '';
  const mapMotif = (name, meaning, alternate = false) => (name || meaning) ? `
    <article>
      <span class="map-motif__mark${alternate ? ' map-motif__mark--alt' : ''}" aria-hidden="true"><i></i></span>
      <div><h4>${escapeHTML(name)}</h4><p>${escapeHTML(meaning)}</p></div>
    </article>` : '';
  const mapDetailMarkup = (button, visualMarkup = '') => {
    const index = String(button.dataset.index || '1').padStart(2, '0');
    const link = button.dataset.link
      ? `<a class="palestine-link map-detail__link" href="${safeStoreURL(button.dataset.link)}">${escapeHTML(button.dataset.linkLabel || 'Explore connected pieces')} <span>↗</span></a>`
      : '';
    return `
      <div class="map-detail__mast">
        <div><p class="eyebrow">${escapeHTML(button.dataset.scope)}</p><h3>${escapeHTML(button.dataset.title)} <span lang="ar" dir="rtl">${escapeHTML(button.dataset.subtitle)}</span></h3></div>
        <span class="map-detail__number">${index}</span>
      </div>
      <p class="map-detail__intro">${escapeHTML(button.dataset.text)}</p>
      ${visualMarkup}
      <div class="map-detail__facts">
        ${mapFact('Regional stitch', 'أسلوب المنطقة', button.dataset.technique, true)}
        ${mapFact('Palette', 'الألوان', button.dataset.palette)}
        ${mapFact('Materials', 'الخامات', button.dataset.materials)}
      </div>
      <div class="map-motifs">
        <p class="map-detail__label"><span>Motifs & meaning</span><em lang="ar" dir="rtl">الرموز والمعنى</em></p>
        ${mapMotif(button.dataset.symbolOne, button.dataset.meaningOne)}
        ${mapMotif(button.dataset.symbolTwo, button.dataset.meaningTwo, true)}
      </div>
      ${link}`;
  };

  function initMapSection(root) {
    const detail = $('[data-map-detail]', root);
    const buttons = $$('[data-map-region]', root);
    const points = $$('[data-map-point]', root);
    const visualTemplates = $$('[data-map-visual]', root);
    if (!detail || !buttons.length || detail.dataset.mapReady === 'true') return;
    detail.dataset.mapReady = 'true';

    const activate = (button, moveFocus = false) => {
      buttons.forEach((region) => {
        const active = region === button;
        region.classList.toggle('active', active);
        region.setAttribute('aria-selected', String(active));
        region.setAttribute('tabindex', active ? '0' : '-1');
      });
      points.forEach((point) => point.classList.toggle('active', point.dataset.mapPoint === button.dataset.mapId));
      detail.classList.remove('is-entering');
      const visualTemplate = visualTemplates.find((template) => template.dataset.mapVisual === button.dataset.mapId);
      detail.innerHTML = mapDetailMarkup(button, visualTemplate?.innerHTML || '');
      const tabId = button.getAttribute('id');
      if (tabId) detail.setAttribute('aria-labelledby', tabId);
      requestAnimationFrame(() => detail.classList.add('is-entering'));
      if (moveFocus) button.focus({ preventScroll: true });
    };

    buttons.forEach((button, index) => {
      button.addEventListener('click', () => activate(button));
      button.addEventListener('keydown', (event) => {
        let next = index;
        if (['ArrowRight', 'ArrowDown'].includes(event.key)) next = (index + 1) % buttons.length;
        else if (['ArrowLeft', 'ArrowUp'].includes(event.key)) next = (index - 1 + buttons.length) % buttons.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = buttons.length - 1;
        else return;
        event.preventDefault();
        activate(buttons[next], true);
      });
    });
    points.forEach((point) => {
      const matchingButton = buttons.find((button) => button.dataset.mapId === point.dataset.mapPoint);
      if (!matchingButton) return;
      point.addEventListener('click', () => activate(matchingButton));
      point.addEventListener('keydown', (event) => {
        if (!['Enter', ' '].includes(event.key)) return;
        event.preventDefault();
        activate(matchingButton, true);
      });
    });
  }
  const mapSections = $$('[data-map-section]');
  if (mapSections.length) mapSections.forEach(initMapSection);
  else initMapSection(document);
  document.addEventListener('shopify:section:load', (event) => {
    const mapSection = event.target.matches?.('[data-map-section]') ? event.target : $('[data-map-section]', event.target);
    if (mapSection) initMapSection(mapSection);
  });

  $('[data-sort-by]')?.addEventListener('change', (event) => {
    const url = new URL(location.href);
    url.searchParams.set('sort_by', event.target.value);
    location.assign(url.toString());
  });

  const productRoot = $('[data-product-root]');
  if (productRoot) {
    let variants = [];
    try { variants = JSON.parse($('[data-product-json]')?.textContent || '[]'); }
    catch (_error) { variants = []; }
    const options = [];
    const variantInput = $('[data-variant-id]');
    const addButton = $('[data-add-to-cart]');
    const stickyButton = $('[data-sticky-add]');
    const inventory = $('[data-inventory]');

    const applyVariant = (selected) => {
      if (!variantInput) return;
      if (!selected) {
        variantInput.value = '';
        if (inventory) inventory.textContent = 'This option combination is unavailable';
        if (addButton) { addButton.disabled = true; addButton.textContent = 'Unavailable'; }
        if (stickyButton) { stickyButton.disabled = true; stickyButton.textContent = 'Unavailable'; }
        return;
      }
      variantInput.value = selected.id;
      const compare = Number(selected.compare_at_price || 0) > Number(selected.price || 0)
        ? `<s>${escapeHTML(money(selected.compare_at_price))}</s>` : '';
      const price = $('[data-product-price]');
      if (price) price.innerHTML = `${escapeHTML(money(selected.price))}${compare}`;
      const stickyPrice = $('[data-sticky-price]');
      if (stickyPrice) stickyPrice.textContent = money(selected.price);
      if (inventory) inventory.innerHTML = selected.available
        ? '<i></i>In stock, ready to be carefully packed' : 'Currently unavailable';
      if (addButton) {
        addButton.disabled = !selected.available;
        addButton.textContent = selected.available ? 'Add to Bag' : 'Sold Out';
      }
      if (stickyButton) {
        stickyButton.disabled = !selected.available;
        stickyButton.textContent = selected.available ? 'Add to Bag' : 'Sold Out';
      }
      const url = new URL(location.href);
      url.searchParams.set('variant', selected.id);
      history.replaceState({}, '', `${url.pathname}${url.search}${url.hash}`);
    };

    variants[0]?.options?.forEach((_value, index) => {
      options[index] = $(`[data-option-index="${index}"].active`)?.dataset.optionValue;
    });
    $$('[data-option-index]').forEach((button) => button.addEventListener('click', () => {
      const index = Number(button.dataset.optionIndex);
      options[index] = button.dataset.optionValue;
      $$(`[data-option-index="${index}"]`).forEach((option) => option.classList.toggle('active', option === button));
      const selected = variants.find((variant) => variant.options.every((option, optionIndex) => options[optionIndex] === option));
      applyVariant(selected);
    }));
    $('[data-product-form]')?.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!variantInput?.value || addButton?.disabled) return;
      if (addButton) { addButton.disabled = true; addButton.textContent = 'Adding…'; }
      try { await addVariant(variantInput.value); }
      catch (error) { alert(error.message); if (addButton) addButton.disabled = false; }
      finally {
        if (addButton) {
          const current = variants.find((variant) => String(variant.id) === String(variantInput.value));
          addButton.disabled = !current?.available;
          addButton.textContent = current ? (current.available ? 'Add to Bag' : 'Sold Out') : 'Unavailable';
        }
      }
    });
    stickyButton?.addEventListener('click', () => addButton?.click());
    const gallery = $('[data-gallery]');
    gallery?.addEventListener('scroll', () => {
      const index = Math.round(gallery.scrollLeft / Math.max(1, gallery.clientWidth));
      $$('[data-gallery-dot]').forEach((dot, dotIndex) => dot.classList.toggle('active', index === dotIndex));
    }, { passive: true });
    $$('[data-gallery-dot]').forEach((dot, index) => dot.addEventListener('click', () => {
      gallery?.scrollTo({ left: gallery.clientWidth * index, behavior: reducedMotion ? 'auto' : 'smooth' });
    }));
  }
})();
